<template>
  <div class="myCollect">
    <div class="collect_header van-hairline--bottom">
      <div
        :class="showIndex == item.index ? 'item active' : 'item'"
        v-for="item in items"
        :key="item.id"
        @click="sclectIndex(item.index)"
      >
        {{ item.name }}
      </div>
    </div>
    <van-empty v-if="list.length == 0" description="暂无数据" />
    <div class="container" v-else>
      <van-list
        class="list"
        v-model="loading"
        :finished="finished"
        :error.sync="error"
        finished-text="没有更多了"
        error-text="请求失败，点击重新加载"
        @load="onLoad"
      >
        <div
          class="item"
          v-for="(item, index) in list"
          :key="index"
          @click="gopage(item)"
        >
          <div class="item_left line2">{{ item.title || item.video_name }}</div>
          <div class="item_right">
            <div class="img_box">
              <img :src="item.image_input || item.video_cover" />
            </div>
          </div>
        </div>
      </van-list>
      <!-- <div class="noSpecial" v-if="lists.length == 0 && showIndex == 2">
        <p>还没有收藏的专题</p>
        <div class="btn">查看热门文章</div>
      </div> -->
      <!-- <p class="noData" v-if="list.length == 0 && showIndex != 2">没有更多了</p> -->
    </div>
  </div>
</template>

<script>
import { Icon, List, Empty } from "vant";
import { getCollect, getVideoCollect } from "@/api/lcapi";
export default {
  name: "MyCollect",
  components: {
    [Icon.name]: Icon,
    [List.name]: List,
    [Empty.name]: Empty
  },
  data() {
    return {
      items: [
        { name: "文章", index: 0 },
        { name: "视频", index: 1 }
        // { name: "专题", index: 2 },
      ], // 头部列表
      showIndex: 0, // 选择状态
      // lists: [],
      limit: 10, // 分页数
      total: "", // 总数
      list: "",
      error: false,
      loading: false,
      finished: false
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    /**
     * nav导航切换
     */
    sclectIndex(index) {
      if (index != this.showIndex) {
        this.showIndex = index;
        this.limit = 10;
        this.list = [];
        this.onLoad();
      }
    },
    /**
     * 跳转详情
     */
    gopage(item) {
      if (this.showIndex == 0) {
        this.$router.push({
          path: "/jiaodian/imgtextDetail",
          query: { id: item.article_id }
        });
        return;
      }
      if (this.showIndex == 1) {
        this.$router.push({
          path: "/video/index",
          query: { id: item.video_id }
        });
      }
    },
    onLoad() {
      const that = this;
      if (this.showIndex == 0) {
        getCollect({ page: 1, limit: that.limit })
          .then(res => {
            that.total = res.data.total;
            that.list = res.data.data;
            // 加载状态结束
            that.loading = false;
            that.limit = that.limit + 10;
            // 数据全部加载完成
            if (that.list.length >= that.total) {
              that.finished = true;
            }
          })
          .catch(err => {
            that.loading = false;
            that.error = true;
          });
      } else {
        getVideoCollect({ page: 1, limit: that.limit })
          .then(res => {
            that.total = res.data.total;
            that.list = res.data.data;
            // 加载状态结束
            that.loading = false;
            that.limit = that.limit + 10;
            // 数据全部加载完成
            if (that.list.length >= that.total) {
              that.finished = true;
            }
          })
          .catch(err => {
            that.loading = false;
            that.error = true;
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.myCollect {
  padding-top: 1rem;
  .collect_header {
    display: flex;
    justify-content: flex-start;
    background: #ffffff;
    line-height: 0.8rem;
    padding: 0 0.3rem;
    position: fixed;
    width: 100%;
    top: 0;
    z-index: 9999;
    .item {
      font-weight: bold;
      font-size: 0.3rem;
      min-width: 1rem;
      color: #999999;
      &.active {
        color: #ff410a;
      }
    }
  }
  .container {
    .list {
      .item {
        min-height: 1rem;
        padding: 0.2rem 0.3rem 0.2rem 0;
        background: #ffffff;
        display: flex;
        justify-content: space-between;
        border-bottom: 0.01rem solid #e9e9e9;
        &:last-child {
          border-bottom: 0;
        }
        .item_left {
          flex: 1;
          width: calc(100% - 1.5rem);
          padding: 0 0.3rem;
        }
        .item_right {
          font-size: 0;
          text-align: right;
          .img_box {
            width: 1.5rem;
            overflow: hidden;
            height: 1rem;
            border-radius: 0.05rem;
            border: 0.01rem solid #e9e9e9;
            font-size: 0;
            img,
            video {
              width: 100%;
              height: 100%;
            }
          }
          .hot {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            height: 0.4rem;
          }
        }
      }
    }
    .noData {
      text-align: center;
      font-size: 0.24rem;
      margin-top: 0.36rem;
      color: #999999;
    }
    .noSpecial {
      p {
        text-align: center;
        font-size: 0.24rem;
        color: #999999;
        line-height: 3rem;
      }
      .btn {
        margin: 0 0.6rem;
        background: #ff410a;
        line-height: 0.7rem;
        text-align: center;
        border-radius: 0.08rem;
        color: #ffffff;
        letter-spacing: 0.06rem;
      }
    }
  }
}
</style>
